<template>
      <div class="container">
        <div class="layout">
            <div class="text-center">
                <h1 class="heading-with-underline mb-4">Help Topics</h1>
            </div>
            <FaqFilterInput class="filter-input" :faqArray="allHelpTopicFaqs" @chosenFaqFromFilter="chosenFaqFromFilter"/>
            <transition name="fade" mode="out-in">
              <div class="info-card-wrapper flex flex-wrap" v-if="helpTopicFaqs === null" key="categories">
                <HelpTopicsCard :helpTopic="helpTopic" v-for="helpTopic in helpTopicsArray" :key="helpTopic.tag" v-show="!hiddenCategories.includes(helpTopic.title)" @topicSelected="updateTopicInView(helpTopic)" @questionSelected="setTopicAndShowQuestion($event, helpTopic)"/>
              </div>
              <div class="help-topics-list" v-else key="faqs">
                <h5 class="text-center mb-4"> <span class="close-faq" @click="resetHelpTopics"><font-awesome-icon :icon="['fal', 'arrow-left']" /> back | </span> <span class="filter-title">"{{topicInView.title}}"</span></h5>
                <p v-if="topicInView.description">{{topicInView.description}}</p>
                <FaqList :faqArray="helpTopicFaqs" :questionIdInView="questionIdInView"/>
              </div>
            </transition>

        </div>
      </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import HelpTopicsCard from '@/components/newHomepage/HelpTopicsCard.vue';
import FaqList from '@/components/helpTopics/FaqList.vue';
import FaqFilterInput from '@/components/helpTopics/FaqFilterInput.vue';

const { mapGetters } = createNamespacedHelpers('helpTopics');

export default {
    name: 'help-topics',
    props: {
        hiddenCategories: {
            type: Array,
            required: false,
            default () {
                return [];
            },
        },
    },
    data () {
        return {
            topicInView: null,
            questionIdInView: null,
        };
    },
    components: {
        HelpTopicsCard,
        FaqList,
        FaqFilterInput,
    },

    methods: {
        updateTopicInView (helpTopic) {
            this.questionIdInView = null;
            this.topicInView = helpTopic;
        },
        resetHelpTopics () {
            this.topicInView = null;
        },
        setTopicAndShowQuestion (questionId, topicInView) {
            this.topicInView = topicInView;
            this.questionIdInView = questionId;
            // log that the topic was opened
            this.$store.dispatch('analytics/sendAnalyticsBeacon', {
                logType: 'faqOpened',
                page: this.$route.fullPath,
                info: questionId,
            });
        },
        chosenFaqFromFilter (chosenFaq) {
            this.questionIdInView = chosenFaq.id;
            this.topicInView = this.helpTopicsArray.find(helpTopic => helpTopic.tag === chosenFaq.tags[0]);
        },
    },

    computed: {
        ...mapGetters(['getHelpTopicFaqsByTag', 'getHelpTopics', 'getHelpTopicFaqsByTagSorted']),
        allHelpTopicFaqs () {
            return this.$store.state.helpTopics.helpTopicFaqs;
        },
        helpTopicFaqs () {
            if (this.topicInView) {
                return this.getHelpTopicFaqsByTagSorted(this.topicInView.tag);
            }
            return null;
        },
        helpTopicsArray () {
            return this.getHelpTopics;
        },

    },

};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_mixins.scss';

    .filter-input{
        margin-top: 20px;
    }
    .input-wrapper {
      justify-content: center;

    }
    .info-card-wrapper {
      flex-wrap: wrap;
      margin-top: 4rem;
      justify-content: space-between;

    }
    .help-topics-list{
      padding: 2rem 6rem 1rem;
      @include responsive("xs") {
        padding: 1rem .5rem;
      }
    }
    .close-faq {
        cursor: pointer;
        display: inline-block;
        margin-right: 0.5rem;
    }
    .filter-title{
        color: var(--secondaryColour);
    }

    .flex-wrap {
    @include responsive("md") {
      flex-wrap: wrap;
    }
    .homepage-card {
      @include responsive("md") {
        flex: 0 0 50%;

      }
      }
    }
    .close-faq {
        cursor: pointer;
        display: inline-block;
        margin-left: 1rem;
    }

    .flex-wrap {
    @include responsive("md") {
      flex-wrap: wrap;
    }
    .homepage-card {
      @include responsive("md") {
        flex: 0 0 50%;

      }
      }
    }

</style>
